import moment from 'moment';

import { DATE_FORMAT } from '../config';

export default function fromNow(val: string) {
  return moment.utc(val, DATE_FORMAT).local().fromNow();
}
